export default "__VITE_ASSET__BRNlrdOD__"